import { ConfirmationModal } from '@/lib/Modals';
import { ModalDescription, ModalTitle } from '@/lib/Modals/common';
import { EmailSendingDomain } from '@/models/emailSendingDomains';
import { IModalContentProps } from '@/models/modals';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useEmailSendingDomainDelete } from './useEmailSendingDomainDelete';

export type DeleteEmailSendingDomainModalProps = {
  domain: EmailSendingDomain;
  deleteFlowId?: string;
  connectorInstanceId?: string;
  onDeleted: () => void;
} & IModalContentProps;

export const DeleteEmailSendingDomainModal: FC<DeleteEmailSendingDomainModalProps> = ({
  domain,
  deleteFlowId,
  connectorInstanceId,
  onDeleted,
  closeModal,
}) => {
  const { t } = useTranslation('campaign');
  const { deleteDomain, isDeleting } = useEmailSendingDomainDelete({ deleteFlowId, connectorInstanceId });

  const handleConfirm = async () => {
    const deleted = await deleteDomain(domain.id);

    if (deleted) {
      closeModal();
      onDeleted();
    }
  };

  return (
    <ConfirmationModal
      onClose={closeModal}
      onConfirm={handleConfirm}
      isLoading={isDeleting}
      cancelText='COMMON.cancel'
      confirmText='campaign.emailWorkspace.domains.deleteConfirm'
    >
      <ModalTitle>{t('emailWorkspace.domains.deleteTitle')}</ModalTitle>
      <ModalDescription>{t('emailWorkspace.domains.deleteDescription', { domain: domain.name })}</ModalDescription>
    </ConfirmationModal>
  );
};
